import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {Record} from 'immutable';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import LocalStorageMixin from 'react-localstorage';
import classnames from 'classnames';
import {Request, POST} from 'requests';
import {default as RequestsMixin, IS_DONE, HAS_FAILED, HAS_ERRORS, IS_NOT_ALLOWED} from 'requests/RequestsMixin';
import {ResourcesMatching, HasErrors} from 'requests/components';
import * as actions from '../actions';
import {default as PasteOrDropzone, SVG, PASTE, DROPZONE} from './PasteOrDropzone';
import OptimizedForSelect from './OptimizedForSelect';
import HelpUploadingIcons from './HelpUploadingIcons';
import SvgInspection from './SvgInspection';

const mapStateToProps = (state, ownProps) => {
  return {
    requests: state.requests,
  };
};

const NewWorkingSetIcon = Record({
  name: null,
  optimizedFor: null,
  logo: false,
  svg: '',
  ignoreWarnings: false,
});

const UploadIconForm = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    kitToken: PropTypes.string.isRequired,
    onUploadIconClicked: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onNotAllowed: PropTypes.func.isRequired,
    isLogo: PropTypes.bool.isRequired,
    isAllowed: PropTypes.bool.isRequired,
  },

  mixins: [RequestsMixin, LocalStorageMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      name: '',
      optimizedFor: '14px',
      showPasteSvgSource: true,
      dropzone: null,
      svgSource: null,
      svgInspection: null,
      svgErrors: null,
    };
  },

  transitions(register) {
    register({
      request: this.requests.uploadWorkingSetIcon,
      to: IS_NOT_ALLOWED,
      call(rm) {
        this.props.onNotAllowed();
      },
    });

    register({
      request: this.requests.uploadWorkingSetIcon,
      to: HAS_FAILED,
      call(rm) {
        this.clearRequests();

        this.state.dropzone.removeAllFiles();
      },
    });

    register({
      request: this.requests.uploadWorkingSetIcon,
      to: HAS_ERRORS,
      call(rm) {
        const svgErrors = rm.requests.errorsFor(this.requests.uploadWorkingSetIcon).get('svg');

        if (typeof svgErrors === "object") {
          this.setState({
            svgInspection: svgErrors[0],
          });
        } else {
          this.setState({
            svgErrors,
          });
        }
      },
    });

    register({
      request: this.requests.uploadWorkingSetIcon,
      to: IS_DONE,
      call(rm) {
        browserHistory.push(`/kits/${this.props.kitToken}/icons`);
      },
    });
  },

  getStateFilterKeys() {
    return ['showPasteSvgSource', 'optimizedFor'];
  },

  handleDropzoneInit(dropzone) {
    this.setState({
      dropzone,
    });
  },

  handleSvgChanged(svgSource) {
    this.setState({
      svgSource,
    });
  },

  handleOptimizedForChanged(value) {
    this.setState({
      optimizedFor: value,
    });
  },

  handleToggleSourceVersusUpload(event) {
    event.preventDefault();

    this.setState({
      showPasteSvgSource: !this.state.showPasteSvgSource,
    });
  },

  handleIconNameChanged(event) {
    this.setState({
      name: this._name.value,
    });
  },

  handleSuggestedFilename(fileName) {
    if (this.state.name === '') {
      this.setState({
        name: fileName,
      });
    }
  },

  handleFileRemoved() {
    this.setState({
      svgInspection: null,
      svgErrors: null,
    });
  },

  uploadRecord(force) {
    return NewWorkingSetIcon({
      name: this._name.value,
      optimizedFor: this.state.optimizedFor,
      logo: this.props.isLogo,
      ignoreWarnings: force,
    });
  },

  uploadSvgSourceClicked(svgSource, force) {
    const record = this.uploadRecord(force)
      .set('svg', svgSource);

    this.setRequest({
      uploadWorkingSetIcon: new Request({
        url: ['api', 'kits', this.props.kitToken, 'working-set-icons'],
        method: POST,
        record,
      }),
    });
  },

  uploadViaDropzoneClicked(dropzoneInstance, force) {
    const record = this.uploadRecord(force);
    const request = new Request({
      url: ['api', 'kits', this.props.kitToken, 'working-set-icons'],
      method: POST,
      record,
    });

    this.setRequest({
      uploadWorkingSetIcon: request,
    }, {skipDispatch: true});

    this.props.dispatch(
      actions.createWorkingSetIconFromDropzone(request, record, dropzoneInstance)
    );
  },

  handleUploadIconClicked() {
    this.props.onUploadIconClicked();

    this.upload();
  },

  handleUploadAnyway() {
    this.upload(true);
  },

  upload(force = false) {
    this.setState({
      svgInspection: null,
      svgErrors: null,
    });

    if (this.props.isAllowed) {
      if (this.state.showPasteSvgSource) {
        this.uploadSvgSourceClicked(this.state.svgSource, force);
      } else {
        this.uploadViaDropzoneClicked(this.state.dropzone, force);
      }
    }
  },

  renderError() {
    const {isAllowed} = this.props;
    const {svgInspection} = this.state;
    let error = null;

    if (!isAllowed) {
      error = (
        <div id="build-error" className="alert alert-primary bg-body" role="alert">
          <strong>Well shoot!</strong> You&apos;ll have to <a href="/upgrade">upgrade</a> before you can add another icon.
        </div>
      );
    }

    if (svgInspection) {
      error = <SvgInspection onContinueAnyway={this.handleUploadAnyway} results={svgInspection} />;
    }

    return error;
  },

  renderUploadIconButton() {
    const {isLogo} = this.props;
    const className = classnames('btn', 'btn-primary', 'btn-block', 'btn-lg');
    const label = (isLogo) ? 'Logo' : 'Icon';

    let uploadIconButtonElement = null;

    if (this.resourceManager().requests.isQueued(this.requests.uploadWorkingSetIcon)) {
      uploadIconButtonElement = (
        <button className={classnames(className, 'disabled')}>
          Uploading {label.toLowerCase()}&hellip;
        </button>
      );
    } else {
      uploadIconButtonElement = (
        <button onClick={this.handleUploadIconClicked} className={className}>
          Upload {label} <i className="ficon ficon-check-circle p-xs-l-xs" />
        </button>
      );
    }

    return uploadIconButtonElement;
  },

  renderPasteOrDropzone(which) {
    const {svgErrors} = this.state;

    return (
      <PasteOrDropzone
        onDropzoneInit={this.handleDropzoneInit}
        onSourceChanged={this.handleSvgChanged}
        onSuggestedFilename={this.handleSuggestedFilename}
        onFileRemoved={this.handleFileRemoved}
        error={svgErrors}
        type={SVG}
        which={which}
      />
    );
  },

  renderCopyPaste() {
    const changeSourceOrUpload = (
      <p className="alt-upload">
        <a onClick={this.handleToggleSourceVersusUpload} href="#">Need to upload an SVG file instead?</a>
      </p>
    );
    return (
      <div>
        {this.renderPasteOrDropzone(PASTE)}
        <div className="form-group row">
          <div className="col-xs-9 col-xs-offset-3">
            {changeSourceOrUpload}
            {this.renderUploadIconButton()}
          </div>
        </div>
      </div>
    );
  },

  renderUpload() {
    const changeSourceOrUpload = (
      <p className="alt-upload">
        <a onClick={this.handleToggleSourceVersusUpload} href="#">Want to paste from Illustrator CC instead?</a>
      </p>
    );

    return (
      <div>
        {this.renderPasteOrDropzone(DROPZONE)}
        <div className="form-group row">
          <div className="col-xs-9 col-xs-offset-3">
            {changeSourceOrUpload}
            {this.renderUploadIconButton()}
          </div>
        </div>
      </div>
    );
  },

  render() {
    const rm = this.resourceManager();
    const formGroupClassName = classnames('form-group', 'row', 'string', 'required');
    const nameFormGroupClassName = classnames(
      formGroupClassName,
      'forms_build_icon_name',
      {'has-danger': rm.requests.errorsFor(this.requests.uploadWorkingSetIcon).get('name')}
    );
    const optimizedForFormGroupClassName = classnames(
      formGroupClassName,
      'forms_build_icon_optimized_for',
    );
    const stopDnD = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const {
      showBuildingIconFor,
    } = this.state;

    return (
      <ResourcesMatching manager={rm}>
        <div className="row m-xs-b-lg" onDragOver={stopDnD} onDrop={stopDnD}>
          <div className="col-xs-8 form-horizontal p-xs-r-xl">
            {this.renderError()}
            <div className={nameFormGroupClassName}>
              <label className="string required col-xs-3 form-control-label p-xs-r-sm">Icon Name <span title="Required">*</span></label>
              <div className="col-xs-9">
                <input ref={(c) => this._name = c} onChange={this.handleIconNameChanged} value={this.state.name} className="string required form-control" type="text" />
                <HasErrors request={this.requests.uploadWorkingSetIcon} errorKey="name">
                  <div className="text-help text-muted">{rm.requests.errorsFor(this.requests.uploadWorkingSetIcon).get('name')}</div>
                </HasErrors>

                <p className="text-muted p-xs-t-xs">Lowercase letters, numbers, and hyphens allowed.</p>
              </div>
            </div>
            <div className={optimizedForFormGroupClassName}>
              <label className="string required col-xs-3 form-control-label p-xs-r-sm">Optimized for <span title="Required">*</span></label>
              <div className="col-xs-9">
                <OptimizedForSelect onChanged={this.handleOptimizedForChanged} value={this.state.optimizedFor} />
                <p className="text-muted p-xs-t-xs">The size you&rsquo;ve designed your icon to look the best at.</p>
              </div>
            </div>
            {(this.state.showPasteSvgSource) ? this.renderCopyPaste() : this.renderUpload()}
          </div>
          <div className="col-xs-4 p-xs-l-xl">
            <div className="alert alert-info bg-body">
              <p className="m-xs-b-0 text-sm">Your icon should be <strong>fully expanded and have no overlapping paths</strong>.</p>
            </div>
            <HelpUploadingIcons />
          </div>
        </div>
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(UploadIconForm);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/UploadIconForm.js